import { useSelector } from "react-redux";

import _ from "lodash"
import { selectListItems } from "../../../../../../redux/library/selector";
import { AccordionContainer } from "../../../../../../common/components/accordion/accordion.module";
import { InputContainer } from "../../../../../../common/components/form/input/containers/input.container";
export default function OnBoardingGSTandPANInfoComponent ({handleFormGSTItemChange,gstInfo,handleFormChange, subscriptionDetails}: any) {
    const libraryData = useSelector(selectListItems)
    return (
      <>
        <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
       <InputContainer
  
  label="PAN Number"
  name="PAN Number"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'OtherDetails.PAN',
      data: subscriptionDetails?.OtherDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.OtherDetails?.PAN}
  />
  <InputContainer
  
  label="Name as per PAN"
  name="Name as per PAN"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'OtherDetails.NameAsPerPAN',
      data: subscriptionDetails?.OtherDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.OtherDetails?.NameAsPerPAN}
  />
  
   </div>
  }
  expandedPanel="PAN Details"
  headerTitle="PAN Details"
/>

<AccordionContainer
      child={
        <div>
        { _.map(
          gstInfo,
          (selectedGst: any, itemIndex: any) => (
                              <div className=" py-4 border-b">
                                <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4">
        <InputContainer
            isRequired
            label="GSTIN"
            name="GSTIN"
            onValueChange={(event: any, newValue: any) => {
              handleFormGSTItemChange({
                value: event.target.value,
                field: 'GSTIN_1',
                idx: itemIndex
              });
            }}
            type="text"
            value={selectedGst?.GSTIN_1}
        />
        
  <InputContainer
  
  label="Name as per GST"
  name="Name as per GST"
  onValueChange={(event: any) => {
    handleFormGSTItemChange({
      value: event.target.value,
      field: 'NameAsPerGSTIN',
      idx: itemIndex
    });
  }}
  type="text"
  value={selectedGst?.NameAsPerGSTIN}
  />

<InputContainer
  
  label="Verified GSTIN Address"
  name="Verified GSTIN Address"
  onValueChange={(event: any) => {
    handleFormGSTItemChange({
      value: event.target.value,
      field: 'VerifiedGSTINAddress',
      idx: itemIndex
    });
  }}
  type="text"
  value={selectedGst?.VerifiedGSTINAddress}
  />
  
   </div>
   </div>
          ))}
          </div>
  }
  expandedPanel="GST Details"
  headerTitle="GST Details"
/>
</>
  )
}